(ns ncr.worker.util
  (:require [cljs.core.async :as a :refer [go <! >! close!]]
            [ncr.etc.xform :as xf]))

(def CLOSE-COMMAND "close")

(defn- send-message [worker payload]
  (.postMessage worker payload)
  worker)

(defn web-worker? []
  (undefined? (.-document js/self)))

(defn- get-terminate-fn
  "Returns worker termination function, depending on where it is called from - worker thread or its parent.
  Accepts `soft-termination?` parameter. When `true`, sends from parent to worker command to close, worker closing
  itself and reports to the parent. When false, terminates worker immediately.

  See https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Terminating_a_worker"
  ([soft-termination?]
   (let [send-close #(send-message % CLOSE-COMMAND)
         do-close #(.close %)]
     (apply
       comp
       (if (web-worker?)
         [do-close send-close]
         (if soft-termination?
           [#(js/console.debug "Requesting soft worker termination…") send-close]
           [#(js/console.debug "Terminating worker hard way") #(.terminate %)])))))
  ([] (get-terminate-fn false)))

(defn- listen-ch [worker on-close]
  (let [c (a/chan 1 (comp
                      (xf/create-simple-xform #(js->clj % :keywordize-keys true))
                      (xf/create-xform (fn [i f] (if (= CLOSE-COMMAND i) (on-close) (f i))))))]
    (set! (.-onmessage worker) #(a/put! c (.-data %)))
    c))

(defn- get-worker-channels [worker]
  (let [write (a/chan 1 (comp (xf/create-simple-xform clj->js) (xf/create-empty-xform (partial send-message worker))))]
    [write (listen-ch worker #(close! write))]))


; # ATTENTION!
;
; - Do not use data ownership transfer, stick with structural copy instead
;   see https://stackoverflow.com/a/34061491/1016019
; - For some unknown reason first `js/setTimeout` call inside worker is expensive, up to 1000ms.
;   It is advised to create a sliding buffer for the progress channel instead of throttling.
;
; # References
;
; - https://tech.grammarly.com/blog/building-etl-pipelines-with-clojure
; - https://www.braveclojure.com/core-async/#Escape_Callback_Hell_with_Process_Pipelines
; - https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout#Reasons_for_delays_longer_than_specified

(def ^:private SOFT-TERMINATION? false)

(defn worker-ch [worker read-fn]
  (let [terminate-fn (get-terminate-fn SOFT-TERMINATION?)
        [write read] (get-worker-channels worker)
        read (read-fn read)]
    (go
      (<! (a/pipe read write))
      (set! (.-onmessage worker) nil)
      (send-message worker CLOSE-COMMAND)
      (terminate-fn worker))
    write))
